 import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// ACTION TYPES
export const FETCH_PARK_USERS_REQUEST = "FETCH_PARK_USERS_REQUEST";
export const FETCH_PARK_USERS_SUCCESS = "FETCH_PARK_USERS_SUCCESS";
export const FETCH_PARK_USERS_FAILURE = "FETCH_PARK_USERS_FAILURE";

export const UPDATE_PARK_USER_REQUEST = "UPDATE_PARK_USER_REQUEST";
export const UPDATE_PARK_USER_SUCCESS = "UPDATE_PARK_USER_SUCCESS";
export const UPDATE_PARK_USER_FAILURE = "UPDATE_PARK_USER_FAILURE";

export const UPDATE_PARK_USER_STATUS_REQUEST = "UPDATE_PARK_USER_STATUS_REQUEST";
export const UPDATE_PARK_USER_STATUS_SUCCESS = "UPDATE_PARK_USER_STATUS_SUCCESS";
export const UPDATE_PARK_USER_STATUS_FAILURE = "UPDATE_PARK_USER_STATUS_FAILURE";


export const fetchParkUsers = ({
  page = 1,
  limit = 10,
  district = "",
  municipality = "",
  search = "",
  sortField = "",
  sortOrder = "asc",
   project_type = "",
}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_PARK_USERS_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const query = new URLSearchParams({
        page,
        limit,
        district,
        municipality,
        search,
        sortField,
        sortOrder,
         project_type, 
      }).toString();

      const response = await axios.get(`${BASE_URL}/v1/api/getAllParkUsers?${query}`, {
        headers: { Authorization: `${token}` },
      });

      dispatch({
        type: FETCH_PARK_USERS_SUCCESS,
        payload: {
          users: response.data.data,
          meta: response.data.meta,
        },
      });
    } catch (error) {
      dispatch({
        type: FETCH_PARK_USERS_FAILURE,
        payload: error.response?.data?.message || error.message,
      });
    }
  };
};


// ----------------------------------------------------------------------
// 2️⃣ UPDATE PARK USER
// ----------------------------------------------------------------------
// export const updateParkUser = (userId, userData) => {
//   return async (dispatch) => {
//     dispatch({ type: UPDATE_PARK_USER_REQUEST });

//     const token = localStorage.getItem("token");

//     try {
//       const res = await axios.put(
//         `${BASE_URL}/v1/api/updateParkUser/${userId}`,
//         userData,
//         { headers: { authorization: token, "Content-Type": "application/json" } }
//       );

//       dispatch({ type: UPDATE_PARK_USER_SUCCESS });
//       toast.success("Park user updated successfully");

//       return res.data;
//     } catch (err) {
//       dispatch({
//         type: UPDATE_PARK_USER_FAILURE,
//         payload: err.response?.data?.message || "Failed to update park user",
//       });
//       toast.error(err.response?.data?.message || "Failed to update park user");
//       throw err;
//     }
//   };
// };

// UPDATE PARK USER
export const updateParkUser = (userId, userData) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_PARK_USER_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const res = await axios.put(
        `${BASE_URL}/v1/api/updateParkUser/${userId}`,
        userData,
        { headers: { authorization: token, "Content-Type": "application/json" } }
      );

      // Dispatch success with the updated user data
      dispatch({
        type: UPDATE_PARK_USER_SUCCESS,
        payload: {
          userId,
          updatedUser: res.data.data || res.data.user || res.data, // Adjust based on your API response structure
        },
      });
      
      toast.success("Park user updated successfully");
      return res.data;
    } catch (err) {
      dispatch({
        type: UPDATE_PARK_USER_FAILURE,
        payload: err.response?.data?.message || "Failed to update park user",
      });
      toast.error(err.response?.data?.message || "Failed to update park user");
      throw err;
    }
  };
};
// ----------------------------------------------------------------------
// 3️⃣ UPDATE PARK USER STATUS
// ----------------------------------------------------------------------
export const updateParkUserStatus = (userId, status) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_PARK_USER_STATUS_REQUEST });

    const token = localStorage.getItem("token");

    try {
      await axios.put(
        `${BASE_URL}/v1/api/updateParkUserStatus/${userId}`,
        { status },
        { headers: { authorization: token, "Content-Type": "application/json" } }
      );

      dispatch({
        type: UPDATE_PARK_USER_STATUS_SUCCESS,
        payload: { userId, status },
      });

      toast.success("Status updated successfully");
    } catch (error) {
      dispatch({
        type: UPDATE_PARK_USER_STATUS_FAILURE,
        payload: error.response?.data?.message || "Status update failed",
      });
      toast.error("Failed to update status");
    }
  };
};
